// The app page's head files, fetched while the visitor reads the landing.
//
// Why (owner report 2026-10-01, Firefox private window on prod: landing → Русский → "Начать учить
// немецкий" → stuck): the app page cannot paint until ~40 head scripts and ~30 stylesheets have
// arrived — 889 KB compressed, main.js alone 309 KB — and until it paints the browser keeps the
// OLD page on screen. On a link that stalls, that is a landing which ignores the click. Measured
// that day: the same machine's IPv4 route to Hetzner dropped and stalled transfers to Hetzner's
// own speed-test hosts too, so it was the network, not the server — and nothing the server does
// can stop a network from being bad. What it can do is move the bytes to before the click.
//
// The files are content-hashed and cached for 30 days, and every button on a landing leads to an
// app page with the SAME list (only the reader-language bundle differs, and that is this page's
// own). So a prefetch here is exactly the download the click would have started, made earlier,
// at the network's lowest priority. The list itself is main.html's, read by AppAssetManifest and
// rendered into landing.html's inert #landingAppAssetsId; this file only decides when and whether.
//
// Like the three files before it, it is a pure enhancement: absent or broken, the click simply
// downloads everything itself, as it always did.
(function () {
    "use strict";

    // ⛔ Not on a device the app does not open on. A finger-only device (phone, tablet, the iPad the
    // User-Agent cannot see) is sent to /desktop by the app page's tour card, so ~900 KB fetched
    // here would be the visitor's mobile data spent on nothing. The test is main.html's own
    // pointer probe, verbatim — the same question, answered the same way, on both pages.
    // Since S8 (tablet-support-plan.md, seam T-11) that includes its split: with learn.touch.tablets
    // on, a finger-only device at least 600 px on its short side is a TABLET, which the app opens on,
    // so it prefetches like a desktop. (Not the css/touch/ sheets: they are not in the list, §7a D3.)
    var touchTablets = !!(document.currentScript
        && document.currentScript.getAttribute("data-touch-tablets") === "true");

    function handheld() {
        return !!(window.matchMedia
            && matchMedia("(any-pointer: coarse)").matches
            && !matchMedia("(any-pointer: fine)").matches
            && !(touchTablets && Math.min(screen.width, screen.height) >= 600));
    }

    // The visitor asked their browser to save data; a speculative megabyte is what that refuses.
    function saveData() {
        return !!(navigator.connection && navigator.connection.saveData);
    }

    var requested = {};
    var started = false;

    function prefetch(href) {
        if (!href || requested[href]) { return; }
        requested[href] = true;
        var link = document.createElement("link");
        link.rel = "prefetch";
        link.href = href;
        document.head.appendChild(link);
    }

    // The reader-language bundle, read off the CTA block at call time: landing_lang.js copies a
    // swapped region's attributes, so after an in-place switch to another language this names
    // THAT language's bundle — and landing_lang.js calls this again once it has swapped.
    function refresh() {
        if (!started) { return; }
        var choice = document.querySelector(".landingChoiceClass");
        prefetch(choice && choice.getAttribute("data-app-i18n"));
    }

    function start() {
        if (handheld() || saveData()) { return; }
        var list = document.getElementById("landingAppAssetsId");
        if (!list || !list.content) { return; }      // no <template> support: nothing to read
        started = true;
        var links = list.content.querySelectorAll("link[href]");
        for (var i = 0; i < links.length; i++) {
            prefetch(links[i].getAttribute("href"));
        }
        refresh();
    }

    window.PL_LANDING_PREFETCH = { refresh: refresh };

    // ⛔ After `load`, never before: the landing's own first paint is bounded by its byte pipe
    // ([[seo-readiness-plan]] §10), and ~70 extra requests during it would tax exactly the paint
    // that decides whether the visitor stays. Same timing, for the same reason, as
    // landing_lang.js's prefetch of the other languages' landings.
    if (document.readyState === "complete") { start(); }
    else { window.addEventListener("load", start, { once: true }); }
})();
